var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("root-layout", { attrs: { moduleCode: _vm.moduleCode } }, [
    _c(
      "div",
      { staticClass: "h-100" },
      [
        !_vm.$route.meta.hideHeader
          ? _c("header-nav", {
              attrs: { moduleCode: _vm.moduleCode },
              scopedSlots: _vm._u(
                [
                  {
                    key: "others-menu",
                    fn: function () {
                      return [_vm._t("header-menu")]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.$route.meta.hideHeader
          ? _c("panel-right", {
              ref: "panelRight",
              scopedSlots: _vm._u(
                [
                  {
                    key: "panel-section-user",
                    fn: function () {
                      return [_vm._t("panel-section-user")]
                    },
                    proxy: true,
                  },
                  {
                    key: "others-panels",
                    fn: function () {
                      return [_vm._t("panel-right-sections")]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            })
          : _vm._e(),
        _vm._v(" "),
        _vm._t("main"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modal modal-terms",
            attrs: { tabindex: "-1", role: "dialog" },
          },
          [
            _c(
              "div",
              { staticClass: "modal-dialog", attrs: { role: "document" } },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v("Política de Privacidade"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("p", [
                      _vm._v(
                        "Veja a nossa politica de privacidade e proteção de dados pessoais e concorde para prosseguirmos"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary text-white",
                        attrs: { href: "/pages/terms.html", target: "_blank" },
                      },
                      [_vm._v("Aceder Politica")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.agreeTerms },
                      },
                      [_vm._v("Concordar e Prosseguir")]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }